<div
    class="bar"
    [style.height.%]="(total / tallestBar) * 100"
>
    <div
        *ngFor="let segment of sortedSegments; let i = index;"
        [style.backgroundColor]="colors[bar.segments.indexOf(segment)]"
        [style.height.%]="(segment.size / total) * 100"
        tooltip="{{segment.name}}, {{isCurrency ? (segment.size / 100 | currency) : segment.size}}"
    >
    </div>
    <label class="x-axis-label" tooltip="{{bar.description}}">
        {{bar.name}}
    </label>
</div>